import { render, staticRenderFns } from "./l-amap-assetarea.vue?vue&type=template&id=60005607&scoped=true&"
import script from "./l-amap-assetarea.vue?vue&type=script&lang=js&"
export * from "./l-amap-assetarea.vue?vue&type=script&lang=js&"
import style0 from "./l-amap-assetarea.vue?vue&type=style&index=0&id=60005607&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60005607",
  null
  
)

export default component.exports